<template>
  <div class="privacy-wave">
    <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="waveGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" :style="{stopColor: startColor, stopOpacity: 1}" />
          <stop offset="100%" :style="{stopColor: endColor, stopOpacity: 1}" />
        </linearGradient>
      </defs>
      <path d="M0 120L60 105C120 90 240 60 360 45C480 30 600 30 720 37.5C840 45 960 60 1080 67.5C1200 75 1320 75 1380 75L1440 75V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="url(#waveGradient)"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'PrivacyWave',
  props: {
    fillColor: {
      type: String,
      default: '#667eea'
    },
    startColor: {
      type: String,
      default: '#2a5298'
    },
    endColor: {
      type: String,
      default: '#f8f9fa'
    }
  }
}
</script>

<style scoped>
.privacy-wave {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 120px;
  overflow: hidden;
  line-height: 0;
  z-index: 1;
}

.privacy-wave svg {
  position: relative;
  display: block;
  width: calc(100% + 1.3px);
  height: 120px;
}

@media (max-width: 768px) {
  .privacy-wave {
    height: 80px;
  }

  .privacy-wave svg {
    height: 80px;
  }
}
</style>

